import styles from './PromotedClubs.module.css';

export function PromotedClubBackground({ color }: { color: string }) {
  return (
    <svg
      className={styles.coloredBackground}
      width="600"
      height="270"
      viewBox="0 0 600 270"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7" filter="url(#blur-bg)">
        <circle cx="calc(100% - 75px)" cy="60" r="75" fill={color} />
      </g>
      <defs>
        <filter id="blur-bg" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feGaussianBlur stdDeviation="67" />
        </filter>
      </defs>
    </svg>
  );
}
